<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" to="/salesrep/list">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width: 100px;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
                      <td style="width:40%; padding-left: 20px;">

                      </td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Sales Rep</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.username }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Location</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{  locations.length>0 ? locations.find(location=>location._id == initvalue.locationid)['locationcode'] : '' }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Active Customers</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.actives.length }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                  </table>
                </v-row>
                <table style="width: 100%">
                  <tr>
                      <td><div align="center"><h4 class="ma-0"><b>Active Customer List</b></h4></div></td>
                  </tr>
                </table>
                <div style="padding: 10px;">&nbsp;</div>
                <table style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Customer</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Address</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Phone</th>
                      <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid">Last Order</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr style="margin-bottom: 10px;" v-for="(trans, index) in initvalue.actives"  v-bind:key="trans._id">
                          <td style="vertical-align: text-top; padding-bottom: 10px; border-bottom: 1px black dotted;">{{ index + 1}}</td>
                          <td style="vertical-align: text-top; border-bottom: 1px black dotted;">
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ trans.customername }}</p>
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ trans.customertype }}</p>
                          </td>
                          <td style="vertical-align: text-top; padding-bottom: 10px; border-bottom: 1px black dotted;">
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ trans.customeraddress }}</p>
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ regions.length>0 ? regions.find(region=>region._id == trans.regionid)['regionname'] : '' }}</p>
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ townships.length>0 ? townships.find(township=>township._id == trans.townshipid)['townshipname'] : '' }}</p>
                          </td>
                          <td style="vertical-align: text-top; border-bottom: 1px black dotted;">
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ trans.customerphone }}</p>
                            <p style="margin-top: 0px; margin-bottom: 0px;">{{ trans.customermobile }}</p>
                          </td>
                          <td style="vertical-align: text-top; border-bottom: 1px black dotted;">
                            <p style="text-align: right; margin-top: 0px; margin-bottom: 0px;"><span style="font-size: 8pt;">Last</span>{{ new Date(trans.lastOrderDate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                            <p style="text-align: right;margin-top: 0px; margin-bottom: 0px;"><span style="font-size: 8pt;">Crte</span>{{ new Date(trans.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</p>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    import { getLogo } from '../../../../util/tools';
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
          };
        },
        computed: {
          ...mapState('District', ['districts']),
          ...mapState('Location', ['locations']),
          ...mapState('Region', ['regions']),
          ...mapState('Township', ['townships']),
          ...mapState('User', ['users']),
        },
        methods: {
          ...mapActions('District', ['getDistrictsRequest']),
          ...mapActions('Township', ['getTownshipsRequest']),
          ...mapActions('Region', ['getRegionsRequest']),
          ...mapActions('Location', ['getLocationsRequest']),
          ...mapActions('User', ['getUsersRequest']),
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          },
          getLast(visits){
            let result = visits.sort(function(a,b){return parseInt(a.visitnum)-parseInt(b.visitnum) }).slice(-1);
            return result[0]!=undefined ? result[0]['visitnum'] : 0
          }
        },
        async created () {
          this.initvalue = this.$route.params;
          this.logo = getLogo(this.initvalue.companyid);
          if(!this.initvalue._id) this.$router.push({ name: 'SalesRepList' });
          if(this.districts.length==0) await this.getDistrictsRequest();
          if(this.regions.length==0) await this.getRegionsRequest();
          if(this.locations.length==0) await this.getLocationsRequest();
          if(this.townships.length==0) await this.getTownshipsRequest();
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
